/* eslint-disable @typescript-eslint/no-explicit-any */

import _ from "lodash";

import type {
    CollectionPropertyType,
    ObjectArrayPropertyType,
    ObjectPropertyType,
    SimpleArrayPropertyType,
    SimplePropertyType,
} from "../types/validation";

export const loadFormStructure = (object: ObjectPropertyType) => {
    const tmpObj: any = {};

    _.forEach(object.properties, (property, name: string) => {
        tmpObj[name] = prepareFormStructure(property);
    });

    return tmpObj;
};

export const prepareFormStructure = (
    property:
        | SimplePropertyType
        | SimpleArrayPropertyType
        | ObjectPropertyType
        | ObjectArrayPropertyType
        | CollectionPropertyType
) => {
    if (property.type === "simple") {
        return "";
    }

    if (property.type === "object") {
        return loadFormStructure(property);
    }

    if (property.type === "simpleArray" || property.type === "objectArray") {
        return [];
    }

    if (property.type === "collection") {
        return {};
    }
};

export const getValueByPath = (obj: any, path: string) => {
    let i;

    const pathAsArray = path.split(".");

    for (i = 0; i < pathAsArray.length && obj !== undefined && obj !== null; i++) {
        if (pathAsArray[i] !== "") {
            obj = obj[pathAsArray[i]];
        }
    }

    return obj;
};

export const setValueByPath = (obj: any, path: string, value: any) => {
    let i;

    const pathAsArray = path.split(".");

    for (i = 0; i < pathAsArray.length - 1; i++) {
        if (pathAsArray[i] !== "") {
            obj = obj[pathAsArray[i]];
        }
    }

    obj[pathAsArray[i]] = value;
};

export const unsetValueByPath = (obj: any, path: string) => {
    let i;

    const pathAsArray = path.split(".");

    for (i = 0; i < pathAsArray.length - 1; i++) {
        if (pathAsArray[i] !== "") {
            obj = obj[pathAsArray[i]];
        }
    }

    if (_.isArray(obj)) {
        obj.splice(parseInt(pathAsArray[i], 10), 1);
    } else {
        delete obj[pathAsArray[i]];
    }
};

export const getFloatFromFloatString = (value: string): number => {
    const newValue = ("" + value).replace(/,/g, ".");

    return parseFloat(newValue);
};

export const getFloatStringFromFloat = (value: number): string => {
    const newValue = ("" + value).replace(/\./g, ",");

    return newValue;
};
